import { Content } from '@prismicio/client';
import { Simplify } from '../../../../../../../prismicio-types';
import { OptimizedPrismicImage } from '@/components';

import styles from './valueCard.module.scss';
import { HistoryIcons } from '../../assets/HistoryIcons';

interface ValueCardProps {
  data:
    | Simplify<
        | Content.OurHistorySliceDefaultPrimaryFirstPhotoCardItem
        | Content.OurHistorySliceDefaultPrimaryThirdPhotoCardItem
      >
    | undefined;
  cardPosition: 'first' | 'last';
  isVisible: boolean;
}

export const ValueCard = ({
  data,
  cardPosition,
  isVisible,
}: ValueCardProps) => {
  if (!data) return null;
  return (
    <div
      className={`${styles.card} ${styles[cardPosition]} ${isVisible ? styles.isVisible : ''}`}
    >
      <div className={styles.image_wrapper}>
        <OptimizedPrismicImage field={data.image} quality={100} />
      </div>
      <div className={`${styles.plate} ${styles[cardPosition]}`}>
        <HistoryIcons icon={data.plate_icon} />
        <span
          className={`${styles.value} ${data.plate_icon === 'no icon' ? styles.noIconValue : ''}`}
        >
          {data.plate_value}
        </span>
        <span className={styles.text}>{data.plate_text}</span>
      </div>
    </div>
  );
};
